export const IMO_DIAGNOSIS_URL =
  'http://woundtech.net/fhir/CodeSystem/woundtech-imo';
